import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren, ReactNode } from "react";
import clsx from "classnames";
import { useDropdown } from "common/hooks/interaction/useDropdown";
interface DropdownProps {
  overlay: ReactNode;
  placement?: "left" | "right";
  wideOverlay?: boolean;
}
export const Dropdown = props => {
  "use memo";

  const $ = _c(15);
  const {
    children,
    overlay,
    placement,
    wideOverlay
  } = props;
  const dropdownPlacement = placement ?? "left";
  const {
    ref,
    isActive,
    onClick
  } = useDropdown();
  let t0;
  if ($[0] !== children || $[1] !== onClick) {
    t0 = <div onClickCapture={onClick} className="inline-flex h-full">{children}</div>;
    $[0] = children;
    $[1] = onClick;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = !isActive;
  const t2 = dropdownPlacement === "right";
  const t3 = !wideOverlay;
  let t4;
  if ($[3] !== t1 || $[4] !== t2 || $[5] !== t3 || $[6] !== wideOverlay) {
    t4 = clsx("absolute flex w-36 min-w-max flex-col border border-t-0 border-gray-100 bg-white", {
      hidden: t1,
      "right-0": t2,
      "w-36": t3,
      "w-48": wideOverlay
    });
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = wideOverlay;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== overlay || $[9] !== t4) {
    t5 = <div className={t4} role="menu" aria-orientation="vertical">{overlay}</div>;
    $[8] = overlay;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== ref || $[12] !== t0 || $[13] !== t5) {
    t6 = <div ref={ref} className="relative inline-block h-full">{t0}{t5}</div>;
    $[11] = ref;
    $[12] = t0;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};